import { useAuth } from 'auth/AuthProvider';
import { useI18n } from 'core/i18n/I18nProvider';
import { Button } from 'shared/components/Button';

export function BackendUnavailablePage() {
  const { t } = useI18n();
  const { retryBootstrap } = useAuth();

  return (
    <main className="boot-screen">
      <h1>{t('auth.backendUnavailableTitle')}</h1>
      <p>{t('auth.backendUnavailableBody')}</p>
      <Button onClick={retryBootstrap}>{t('actions.retry')}</Button>
    </main>
  );
}
